import { h } from "preact";

export const StoryTitle = ({ story }) => {
    const url = story.url || `/item/${story.id}`;
    return <a href={url}>{story.title}</a>;
};
